"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageBanner;
const react_1 = __importDefault(require("react"));
const ImageBanner_module_scss_1 = __importDefault(require("./ImageBanner.module.scss"));
const dispatchAnalytics_1 = require("../../../utils/dispatchAnalytics");
function ImageBanner({ ctaLink, clickUrl, impressionUrl, associatedAdvertId, desktopImage, accessibilityText, }) {
    return (react_1.default.createElement("a", { href: ctaLink, target: "_blank", rel: "noreferrer", className: ImageBanner_module_scss_1.default.bannerLink, "data-testid": "nav-flyout-image-banner-link", onClick: () => {
            (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                action: "kevel.clicked",
                type: "banner",
                adId: associatedAdvertId,
                clickUrl,
                impressionUrl,
            });
        } },
        react_1.default.createElement("img", { "data-testid": "nav-flyout-image-banner-image", src: desktopImage, className: ImageBanner_module_scss_1.default.bannerImage, alt: accessibilityText })));
}
